import React, {PropTypes} from 'react';
import moment from 'moment';
import classNames from 'classnames';
import DisplayIf from 'shared/DisplayIf.jsx';

const BundlingRuleItem = ({
  id,
  quantity,
  parentEventName,
  childEventName,
  creationDate,
  inactiveDate,
  editing,
  onSwitchClick,
  description
}) => (
  <div
    className={classNames(
      'list-group-item-labeled hover-highlight',
      {'highlight animated flipInX': editing}
    )}
  >
    <div
      className="list-group-item-labeled-child"
    >
      <span>{'Rule '}
      {
        creationDate
        ? `(Created: ${moment.parseZone(creationDate).format('MMM Do, YYYY')})`
        : ''
      }
      </span>
      <p>
        Buying 1 <strong>{parentEventName} Entry</strong> allows purchase of <strong>{quantity}</strong> <strong>{childEventName} {quantity === 1 ? 'Entry' : 'Entries'}</strong> on the next day.
      </p>
      <DisplayIf condition={description === 'Split squad bundling is active.'}>
        <p>
          {description}
        </p>
      </DisplayIf>
    </div>
    {
      id && !inactiveDate && description !== 'Split squad bundling is active.'
      ? <div
          className="list-group-item-labeled-child"
          style={{width: 80}}
        >
          <button
            className="btn btn-link"
            style={{padding:0}}
            type="button"
            onClick={() => onSwitchClick({
              id,
              quantity,
              parentEventName,
              childEventName,
              description
            })}
          ><i
            className="fa fa-toggle-on"
            style={{fontSize: 36}}
          /></button>
        </div>
      : null
    }
  </div>
);

BundlingRuleItem.propTypes = {
  id: PropTypes.string,
  quantity: PropTypes.number,
  parentEventName: PropTypes.string,
  childEventName: PropTypes.string,
  creationDate: PropTypes.string,
  inactiveDate: PropTypes.string,
  editing: PropTypes.bool,
  onSwitchClick: PropTypes.func,
  description: PropTypes.string
};

export default BundlingRuleItem;



// WEBPACK FOOTER //
// ./src/features/tournament/restrictions/bundles/BundlingRuleItem.jsx